
const DISCORD_INVITE = 'https://crypto-shots.com/discord';
exports.DISCORD_INVITE = DISCORD_INVITE;
